import React from "react";
import {
  Ballot,
  OndemandVideo,
  PhotoSizeSelectLarge,
  PhotoSizeSelectActual,
  FormatQuote
} from "@material-ui/icons";
import { StyledContainer, SectionName, SectionTitle } from "../../Home.styles";
import {
  GridWrapper,
  ItemTitle,
  ItemDescription,
  ItemIcon,
  QuoteWrapper,
  Wrapper,
  Image,
  SmallBannerWrapper,
  BigBannerWrapper,
  VideoBannerWrapper,
  PollBannerWrapper
} from "./OurOffer.styles";
import small from '../../../assets/Banners/small.png';
import small02 from '../../../assets/Banners/small02.png';
import big from '../../../assets/Banners/big.png';
import big02 from '../../../assets/Banners/big02.png';
import video from '../../../assets/Banners/video.png';
import video02 from '../../../assets/Banners/video02.png';
import poll from '../../../assets/Banners/poll.jpg';
import poll02 from '../../../assets/Banners/poll02.jpg';

export function OurOffer() {
  return (
    <StyledContainer>
      <SectionName center={true}>our offer</SectionName>
      <SectionTitle center={true}>
        Learn more about types of campaigns
      </SectionTitle>
      <GridWrapper>
        <Wrapper>
          <ItemIcon backgroundColor="#f7b50026" iconColor="#F7B500">
            <PhotoSizeSelectLarge />
          </ItemIcon>
          <div>
            <ItemTitle>Medium Rectangle</ItemTitle>
            <ItemDescription>
              This campaign consists of rectangular images that redirect users to the targeted pages. These images will be suitably positioned within DoveMed content pages.
            </ItemDescription>
            <QuoteWrapper iconColor="#F7B500">
              <FormatQuote />
              <div>
                <p>
                  DovePoints Campaigns offer great flexibility in choice of ads. Awesome indeed!
                </p>
                <h3>Linda Lynch</h3>
              </div>
            </QuoteWrapper>
          </div>
        </Wrapper>
        <Image align='flex-end'>
          <SmallBannerWrapper>
            <img src={small} alt='Small' />
            <img src={small02} alt='Small02' />
          </SmallBannerWrapper>
        </Image>
      </GridWrapper>
      <GridWrapper reverse={true}>
        <Image align='center'>
          <BigBannerWrapper>
            <img src={big} alt='Big' />
            <img src={big02} alt='Big02' />
          </BigBannerWrapper>
        </Image>
        <Wrapper>
          <ItemIcon backgroundColor="#2a71d426" iconColor="#2A71D4">
            <PhotoSizeSelectActual />
          </ItemIcon>
          <div>
            <ItemTitle>Leaderboard</ItemTitle>
            <ItemDescription>
              This campaign consists of horizontal images with links that redirects users to the targeted pages. These images will be suitably positioned within DoveMed content pages.
            </ItemDescription>
            <QuoteWrapper iconColor="#2A71D4">
              <FormatQuote />
              <div>
                <p>
                  Innovative product - it allows to showcase ads based on certain specialties and geo-locations.
                </p>
                <h3>Terry Morales</h3>
              </div>
            </QuoteWrapper>
          </div>
        </Wrapper>
        </GridWrapper>
      <GridWrapper>
        <Wrapper>
          <ItemIcon backgroundColor="#d8431526" iconColor="#D84315">
            <OndemandVideo />
          </ItemIcon>
          <div>
            <ItemTitle>Video</ItemTitle>
            <ItemDescription>
              This campaign consists of videos that are embedded on DoveMed pages. Users clicking on these can watch the embedded videos anywhere within the DoveMed site, wherever it is placed.
            </ItemDescription>
            <QuoteWrapper iconColor="#D84315">
              <FormatQuote />
              <div>
                <p>
                  Posting a video based ad has never been this easy and simple. Wonderful! 
                </p>
                <h3>Richard Duncan</h3>
              </div>
            </QuoteWrapper>
          </div>
        </Wrapper>
        <Image align='flex-end'>
          <VideoBannerWrapper>
            <img src={video} alt='Video' />
            <img src={video02} alt='Video02' />
          </VideoBannerWrapper>
        </Image>
      </GridWrapper>
      <GridWrapper reverse={true}>
        <Image align='center'>
          <PollBannerWrapper>
            <img src={poll} alt='Poll' />
            <img src={poll02} alt='Poll02' />
          </PollBannerWrapper>
        </Image>
        <Wrapper>
          <ItemIcon backgroundColor="#44d7b626" iconColor="#44D7B6">
            <Ballot />
          </ItemIcon>
          <div>
            <ItemTitle>Poll</ItemTitle>
            <ItemDescription>
              This campaign consists of questions and answer response options that help gather information, such as public opinion, related to a product. These polls will be suitably positioned within DoveMed content pages.
            </ItemDescription>
            <QuoteWrapper iconColor="#44D7B6">
              <FormatQuote />
              <div>
                <p>
                  Amazing. Couldn’t find many other portals that allow you to run poll ads.
                </p>
                <h3>Melissa Hoffman</h3>
              </div>
            </QuoteWrapper>
          </div>
        </Wrapper>
      </GridWrapper>
    </StyledContainer>
  );
}
